import {
  InstallationStep,
  InstallationStepId,
  InstallationStepStatus,
  UsageChart,
} from '@core/models/model';
import { ContractResponse, SubscriptionResponse } from '@core/contracts/data-contracts';

export type DefaultObject = {
  overviewUsageChart: UsageChart;
  subscription: SubscriptionResponse;
  contract: ContractResponse;
};
export const DefaultData: DefaultObject = {
  overviewUsageChart: {
    megabytesRemaining: 0,
    megabytesTotal: 0,
    minutesRemaining: 0,
    minutesTotal: 0,
    untilNewCredit: 0,
    extraPrice: 0,
    isDataOnly: null,
  },

  subscription: {
    startDate: null,
    endDate: null,
    prolongationDate: null,
    contractDuration: 0,
    name: 'N/A',
  },

  contract: {
    clientNumber: 0o0,
    phoneNumber: 'N/A',
    name: 'N/A',
  },
};

// TODO: replace with API data once the installation status endpoint is available
export const INSTALLATION_STEPS_MOCK: InstallationStep[] = [
  {
    id: InstallationStepId.Hardware,
    status: InstallationStepStatus.Active,
    details: {
      items: [
        { label: 'ONT Glasvezel aansluitbox (kpn)', date: '12-06-2026' },
        { label: 'Installatiepakket incl. modem', date: '14-06-2026' },
      ],
    },
  },
  {
    id: InstallationStepId.Activation,
    status: InstallationStepStatus.Pending,
    activationDate: '2026-10-20',
  },
  {
    id: InstallationStepId.Installation,
    status: InstallationStepStatus.Pending,
  },
];

// TODO: replace with API data once the installation status endpoint is available
export const INSTALLATION_STEPS_TECHNICIAN_MOCK: InstallationStep[] = [
  {
    id: InstallationStepId.Hardware,
    status: InstallationStepStatus.Done,
    completedAt: '2026-06-15',
    details: {
      items: [
        { label: 'ONT Glasvezel aansluitbox (kpn)', date: '12-06-2026' },
        { label: 'Installatiepakket incl. modem', date: '14-06-2026' },
      ],
    },
  },
  {
    id: InstallationStepId.Activation,
    status: InstallationStepStatus.Done,
    completedAt: '2026-06-17',
    activeSince: '2026-06-17',
  },
  {
    id: InstallationStepId.Installation,
    status: InstallationStepStatus.Active,
    installationDate: '2026-10-20',
  },
];

// TODO: replace with API data once the installation status endpoint is available
export const INSTALLATION_STEPS_DONE_MOCK: InstallationStep[] = [
  {
    id: InstallationStepId.Hardware,
    status: InstallationStepStatus.Done,
    completedAt: '2026-06-15',
    details: {
      items: [
        { label: 'ONT Glasvezel aansluitbox (kpn)', date: '12-06-2026' },
        { label: 'Installatiepakket incl. modem', date: '14-06-2026' },
      ],
    },
  },
  {
    id: InstallationStepId.Activation,
    status: InstallationStepStatus.Done,
    completedAt: '2026-06-17',
    activeSince: '2026-06-17',
  },
  {
    id: InstallationStepId.SelfInstallation,
    status: InstallationStepStatus.Done,
    completedAt: '2026-06-17',
    details: {
      items: [{ label: 'Installatiepakket incl. modem', date: '17-06-2026' }],
    },
  },
];
